import { notification } from 'antd';

export const LCNotification = notification;